import store from '../store';

export const getChatReducer = (state = store) => state.chatsReducer

export const getChatPagePopout = (state = store) => getChatReducer(state).chatPagePopout
